import { QueryClient } from '@tanstack/react-query'
import { ApiError, createApiClient } from '@ousse/shared'

/** Client de l'API (même origine : cookie de session HttpOnly). */
export const api = createApiClient()

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof ApiError && error.status > 0 && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
})

export const errorCode = (error: unknown) => (error instanceof ApiError ? error.code : 'internal_error')
